import { SettingsTemplate } from "../../../template/settings/default-template";
import {
  ExternalLink,
  InformationBanner,
} from "@graffer-inc/console-design-kit";
import FaqScreen from "./../../../../assets/faq-screen.svg";
import JobTrainingMovieScreen from "./../../../../assets/job-training-movie-screen.svg";
import { HelpR } from "../../help/route";
import { Link } from "react-router-dom";

export const ServiceHelpPage: React.FC = () => {
  return (
    <SettingsTemplate breadcrumbs={[{ to: "#", title: "ヘルプ" }]}>
      <div style={{ maxWidth: "900px" }}>
        <div>
          <h1 className="title">ヘルプ</h1>
          <p>
            当社サービスを利用いただいている皆様向けに、ヘルプサイトをご用意しております。
            <br />
            ご質問をよくいただくプロダクトの操作方法や活用事例等を公開しております。
            <br />
            こちらをご活用ください。
          </p>
          <ExternalLink
            anchor={(props) => <Link {...props} to={HelpR.HelpHome.link({})} />}
            fontWeight="bold"
          >
            ヘルプサイトへ遷移する
          </ExternalLink>
          <p>
            また、過去のインターネット環境用のヘルプサイトもご覧いただけます。
          </p>
          <div className="content">
            <dl>
              <dt className="mt-1" style={{ float: "left" }}>
                URL:
              </dt>
              <dd>
                <ExternalLink
                  anchor={(props) => (
                    <a {...props} href={"https://graffer.ttzk.me/"} />
                  )}
                >
                  https://graffer.ttzk.me/
                </ExternalLink>
              </dd>
              <dt style={{ float: "left" }}>パスワード:&nbsp;</dt>
              <dd className="ml-9">udhy96</dd>
            </dl>
          </div>
          <InformationBanner message="LGWAN環境では上記のURLをクリックしても表示されません。インターネット環境にてご覧ください。" />
        </div>
        <div className="mt-5">
          <h2 className="title is-size-4">
            下記のコンテンツをご覧いただけます。
          </h2>
          <div
            className="columns m-0"
            style={{ outline: "2px ridge rgba(207, 212, 224, 0.3)" }}
          >
            <div className="column is-half">
              <h3 className="is-size-5">よくあるご質問</h3>
              <figure className="image is-text-centered">
                <img src={FaqScreen} alt="よくあるご質問ページの画面" />
              </figure>
            </div>
            <div className="column is-half container">
              <h3 className="is-size-5">研修動画、活用事例など</h3>
              <figure className="image">
                <img
                  src={JobTrainingMovieScreen}
                  alt="よくあるご質問ページの画面"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </SettingsTemplate>
  );
};
